import classNames from "classnames";
import styles from "./style.module.scss";
import { Icons } from "assets";
import { useEffect, useState } from "react";
import { GetNewOrganizationsService } from "shared/services/dashboard";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";
import SekeletonLoader from "shared/loaders/skeleton";

const OrganizationCard = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [organizations, setOrganizations] = useState<string[]>([]);

  const handleGetNewOrganizations = () => {
    setLoading(true);
    GetNewOrganizationsService({ count: "4" })
      .then(({ data }) => {
        setOrganizations(data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetNewOrganizations();
  }, []);

  return (
    <div className={classNames(styles.orgCard, "gap-5")}>
      <div className={classNames("flex flex-col gap-2")}>
        <h1>New Organizations</h1>
        <p>List of newly registered organizations</p>
        <div className={classNames("flex flex-col gap-4 mt-3")}>
          {loading ? (
            <>
              {Array.from({ length: 4 }).map((_, index) => (
                <div
                  className={classNames("flex items-center gap-2")}
                  key={index}
                >
                  <SekeletonLoader className={classNames(styles.avtLoader)} />
                  <div className={classNames("flex flex-col w-full gap-1")}>
                    <SekeletonLoader
                      className={classNames(styles.titleLoader)}
                    />
                    <SekeletonLoader
                      className={classNames(styles.paraLoader)}
                    />
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              {organizations?.map((item: any, index: number) => (
                <div
                  className={classNames("flex items-center gap-2")}
                  key={index}
                >
                  <div className={classNames(styles.avtContainer)}>
                    <label>
                      {item?.name?.split(" ")?.[0]?.[0]}
                      {item?.name?.split(" ")?.[1]?.[0]}
                    </label>
                  </div>
                  <div className={classNames("flex flex-col")}>
                    <h2>{item?.name}</h2>
                    <p>
                      {item?.users_count ? item?.users_count : 0} Associated
                      Users
                    </p>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
      <div
        className={classNames("flex items-center gap-1 cursor-pointer w-fit")}
        onClick={() => {
          navigate(routeConstant.organizations.path);
        }}
      >
        <h3>View All Organizations</h3>
        <Icons.ArrowRight />
      </div>
    </div>
  );
};

export default OrganizationCard;
